import * as React from "react";
import { TinTuc, TinTucNew } from "../../models";
import TinTucService from "../../services/tinTuc";
import { DANH_MUC } from "../../const/danh-muc";
import Image from "../../components/share/Image"
import ModalTinTuyenSinh from "./ModalTinTuyenSinh";
import SpinnersImage from "../share/Spinners/SpinnersImage";
import SpinnersImageTextNgang from "../share/Spinners/SpinnersImageTextNgang";




export interface State {
  tinTuyenSinh: TinTucNew[];
}

class ThongTinTuyenSinh extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      tinTuyenSinh: [],
      loading: false
    };
  }

  componentDidMount() {
    TinTucService.getTinNoiBat(DANH_MUC.TUYEN_SINH, 3).then(result => {
      this.setState({ tinTuyenSinh: result.tinTuc, loading: true });
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className="row content">
          <div className="col-md-12 p-0">
            <div className="back-white title text-green">
              ADMISSIONS INFORMATION
            </div>
          </div>
        </div>
        {
          this.state.loading ? (
            <div>
              {this.state.tinTuyenSinh.map(tinTuc => {
                return (
                  <div className="row content back-white" key={tinTuc.id}>
                    <div className="col-md-4 nopadding">
                      <Image className="img-fluid" src={tinTuc.image} classPlaceHolder="lazy-image-thong-tin-tuyen-sinh" />
                    </div>
                    <div className="col-md padding-top">
                      <a
                        href="#"
                        className="btn-thongtintuyensinh text-red trimtext3"
                        data-toggle="modal"
                        data-target={`#${tinTuc.id}`}
                        style={{textTransform: "uppercase"}}
                      >
                        {tinTuc.tieuDe}
                      </a>
                      <p className="trimtext">
                        {tinTuc.moTa}
                      </p>
                    </div>
                  </div>
                );
              })}

              {this.state.tinTuyenSinh.map(tinTuc => {
                return (
                  <ModalTinTuyenSinh
                    key={tinTuc.id}
                    tinTucUrl={tinTuc.url}
                    id={tinTuc.id}
                  />
                );
              })}
            </div>
          ) : <SpinnersImageTextNgang type={'placeholde'} loading={true} />
        }
      </React.Fragment>
    );
  }
}

export default ThongTinTuyenSinh;
